import React from "react"
import { Route, Redirect } from "react-router-dom"
import useAuthListener from "../hooks/useAuthListener"
import useVerifyToken from "../hooks/useVerifyToken"

export default function PrivateRoute({ children, ...rest }) {
  const token = useVerifyToken()
  useAuthListener()
  return (
    <Route
      {...rest}
      render={({ location }) =>
        token ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        )
      }
    />
  )
}
